export function useMockNextYearPlansFlag(): boolean {
  const { sentryEnv } = useRuntimeConfig().public
  const isAllowedEnv = ['QA', 'Development'].includes(sentryEnv as string)

  const { flag } = FeatureFlags.use()
  return isAllowedEnv && flag('mock-next-year-plans', false).value
}
